import React from 'react';
import { Link } from 'react-router-dom';
import './primitives.css';

const iconPaths = {
  warning: <><path d="M12 3l9 16H3l9-16z" /><path d="M12 10v4M12 17h.01" /></>,
  // Category labels. Added for the task list, which was still using a 🏷️ emoji for the
  // one thing in the app that is literally a tag.
  tag: <><path d="M3 12V5a2 2 0 0 1 2-2h7l9 9-9 9-9-9z" /><path d="M7.5 7.5h.01" /></>,

  // Added to retire the last emoji in the bottom navigations and split button menus.
  // Each replaces a specific glyph the app was using as chrome: 🔐 🏠 📡 🔌 📐 📝.
  lock: <><rect x="4" y="10" width="16" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3" /></>,
  home: <><path d="M3 11l9-8 9 8" /><path d="M5 10v10h14V10" /></>,
  broadcast: <><circle cx="12" cy="12" r="2.5" /><path d="M7.5 7.5a6.4 6.4 0 0 0 0 9M16.5 7.5a6.4 6.4 0 0 1 0 9" /><path d="M4.5 4.5a10.6 10.6 0 0 0 0 15M19.5 4.5a10.6 10.6 0 0 1 0 15" /></>,
  plug: <><path d="M9 3v6M15 3v6" /><path d="M6 9h12v3a6 6 0 0 1-12 0z" /><path d="M12 18v3" /></>,
  ruler: <><rect x="2" y="8" width="20" height="8" rx="1.5" /><path d="M7 8v3M12 8v4M17 8v3" /></>,
  note: <><path d="M5 3h9l5 5v13H5z" /><path d="M14 3v5h5" /><path d="M9 13h6M9 17h4" /></>,

  // The remainder of the emoji the application was using as chrome. Added as one batch
  // after an audit counted them, rather than one per screenshot: 52 distinct glyphs were
  // in use and 40 of them had nothing in the set to become.
  mail: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></>,
  save: <><path d="M5 3h11l3 3v15H5z" /><path d="M8 3v6h7V3" /><rect x="8" y="13" width="8" height="8" /></>,
  inbox: <><path d="M3 13h5l1 3h6l1-3h5" /><path d="M5 5h14l2 8v6H3v-6z" /></>,
  heart: <><path d="M12 20s-7-4.6-7-9.4A4.1 4.1 0 0 1 12 8a4.1 4.1 0 0 1 7 2.6C19 15.4 12 20 12 20z" /></>,
  bulb: <><path d="M9 18h6" /><path d="M10 21h4" /><path d="M12 3a6 6 0 0 0-3.5 10.9c.4.3.5.7.5 1.1h6c0-.4.1-.8.5-1.1A6 6 0 0 0 12 3z" /></>,
  menu: <><path d="M4 7h16M4 12h16M4 17h16" /></>,
  pause: <><rect x="7" y="5" width="3.5" height="14" /><rect x="13.5" y="5" width="3.5" height="14" /></>,
  book: <><path d="M4 4.5A2.5 2.5 0 0 1 6.5 2H20v18H6.5A2.5 2.5 0 0 0 4 22z" /><path d="M4 17.5A2.5 2.5 0 0 1 6.5 15H20" /></>,
  phone: <><rect x="6" y="2" width="12" height="20" rx="2.5" /><path d="M11 18h2" /></>,
  chat: <><path d="M20 15a2 2 0 0 1-2 2H8l-4 4V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z" /></>,
  undo: <><path d="M4 10h10a5 5 0 0 1 0 10h-3" /><path d="M8 6l-4 4 4 4" /></>,
  package: <><path d="M21 8v8l-9 5-9-5V8l9-5z" /><path d="M3 8l9 5 9-5" /><path d="M12 13v8" /></>,
  cart: <><circle cx="9" cy="20" r="1.3" /><circle cx="18" cy="20" r="1.3" /><path d="M2 3h3l2.5 12h11L21 7H6" /></>,
  file: <><path d="M6 2h8l5 5v15H6z" /><path d="M14 2v5h5" /></>,
  mic: <><rect x="9.5" y="2" width="5" height="11" rx="2.5" /><path d="M5.5 11a6.5 6.5 0 0 0 13 0" /><path d="M12 17.5V21" /></>,
  medal: <><circle cx="12" cy="15" r="5" /><path d="M9 10L6.5 2h11L15 10" /><path d="M12 13l.8 1.7 1.9.3-1.4 1.3.3 1.9-1.6-.9-1.6.9.3-1.9L9.3 15l1.9-.3z" /></>,
  infinity: <><path d="M8.5 9a3.5 3.5 0 1 0 0 6c2.6 0 4-6 7-6a3.5 3.5 0 1 1 0 6c-3 0-4.4-6-7-6z" /></>,
  expand: <><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" /></>,
  scroll: <><path d="M6 3h12v15a3 3 0 0 1-3 3H6a3 3 0 0 0 3-3z" /><path d="M9 7h6M9 11h6" /></>,
  arrowUpRight: <><path d="M7 17L17 7" /><path d="M9 7h8v8" /></>,
  recycle: <><path d="M7 7l2.5-4 2.5 4" /><path d="M17 11l2 4-4.5.5" /><path d="M6 15l-2 3h5" /><path d="M9.5 3L5 11M19 15l-4.5 1M4 18h9l2-3.5" /></>,
  refresh: <><path d="M20 12a8 8 0 1 1-2.3-5.6" /><path d="M20 4v5h-5" /></>,
  clipboard: <><rect x="7" y="4" width="10" height="17" rx="2" /><path d="M9 4V3h6v1" /><path d="M9 10h6M9 14h6" /></>,
  // Duplicating something, as distinct from `clipboard` (a list on a board). At 16px the
  // clipboard's body and two rules read as a battery, so a Copy button gets these two
  // overlapping sheets instead - the mark people already know from every other app.
  copy: <><rect x="10" y="10" width="11" height="11" rx="2" /><path d="M6 16H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></>,
  checkCircle: <><circle cx="12" cy="12" r="9" /><path d="M8 12.5l2.5 2.5L16 9.5" /></>,
  xCircle: <><circle cx="12" cy="12" r="9" /><path d="M9 9l6 6M15 9l-6 6" /></>,
  trash: <><path d="M4 7h16" /><path d="M9 7V5h6v2" /><path d="M6 7l1 13h10l1-13" /><path d="M10 11v6M14 11v6" /></>,
  link: <><path d="M10 13a4 4 0 0 0 5.7 0l3-3a4 4 0 1 0-5.7-5.7L11.5 5.8" /><path d="M14 11a4 4 0 0 0-5.7 0l-3 3a4 4 0 1 0 5.7 5.7l1.5-1.5" /></>,
  pin: <><path d="M12 21s7-6.3 7-11a7 7 0 1 0-14 0c0 4.7 7 11 7 11z" /><circle cx="12" cy="10" r="2.5" /></>,
  settings: <><circle cx="12" cy="12" r="3" /><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M19.1 4.9L17 7M7 17l-2.1 2.1" /></>,
  star: <path d="M12 3.5l2.6 5.6 6 .7-4.4 4.2 1.1 6-5.3-3-5.3 3 1.1-6L3.4 9.8l6-.7L12 3.5z" />,
  block: <><circle cx="12" cy="12" r="9" /><path d="M5.6 5.6l12.8 12.8" /></>,
  plus: <path d="M12 5v14M5 12h14" />,
  minus: <path d="M5 12h14" />,
  edit: <path d="M4 20h4l10-10-4-4L4 16v4zM12 6l4 4" />,
  arrowRight: <path d="M5 12h14M13 5l7 7-7 7" />,
  arrowLeft: <path d="M19 12H5M11 5l-7 7 7 7" />,
  chevronRight: <path d="M9 6l6 6-6 6" />,
  chevronLeft: <path d="M15 6l-6 6 6 6" />,
  dot: <circle cx="12" cy="12" r="5" fill="currentColor" stroke="none" />,
  dotOutline: <circle cx="12" cy="12" r="5" />,
  ticket: <><path d="M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2 2 2 0 0 0 0 6 2 2 0 0 1-2 2H5a2 2 0 0 1-2-2 2 2 0 0 0 0-6z" /><path d="M14 7v10" /></>,
  thumbsUp: <><path d="M7 11v9H4v-9h3z" /><path d="M7 11l4-7a2 2 0 0 1 3 1.7V10h4.5a2 2 0 0 1 2 2.4l-1.2 5.6a2 2 0 0 1-2 1.6H7" /></>,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3.5 2" /></>,
  bolt: <path d="M13 3L5 13h5l-1 8 8-10h-5l1-8z" />,
  shuffle: <><path d="M4 6h4l8 12h4" /><path d="M4 18h4l2-3" /><path d="M18 3l3 3-3 3M18 15l3 3-3 3" /></>,
  chevronUp: <path d="M6 15l6-6 6 6" />,
  filter: <><path d="M3 5h18l-7 8v5l-4 2v-7z" /></>,
  search: <><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></>,
  calendar: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18M8 3v4M16 3v4" /></>,
  check: <path d="M5 13l4 4L19 7" />,
  x: <path d="M6 6l12 12M18 6L6 18" />,
  chevronDown: <path d="M6 9l6 6 6-6" />,
  info: <><circle cx="12" cy="12" r="10" /><path d="M12 16v-4M12 8h.01" /></>,
  user: <><circle cx="12" cy="8" r="4" /><path d="M4 20c1.5-3.5 4.4-5 8-5s6.5 1.5 8 5" /></>,
  users: <><circle cx="9" cy="9" r="3" /><circle cx="16" cy="8" r="2.5" /><path d="M3 19c1.2-2.7 3.2-4 6-4" /><path d="M12 19c1-2 2.6-3 4.8-3" /></>,
  trophy: <><path d="M8 4h8v3a4 4 0 0 1-8 0V4z" /><path d="M10 14h4M9 18h6" /><path d="M7 6H5a2 2 0 0 0 0 4h2" /><path d="M17 6h2a2 2 0 1 1 0 4h-2" /></>,
  swords: <><path d="M6 18l5-5" /><path d="M13 6l5-5" /><path d="M5 5l14 14" /><path d="M7 3l2 2" /><path d="M15 11l2 2" /></>,
  sparkles: <><path d="M12 3l1.6 3.4L17 8l-3.4 1.6L12 13l-1.6-3.4L7 8l3.4-1.6L12 3z" /><path d="M5 14l.9 1.9L8 17l-2.1 1.1L5 20l-.9-1.9L2 17l2.1-1.1L5 14z" /><path d="M19 13l.7 1.4L21 15l-1.3.6L19 17l-.7-1.4L17 15l1.3-.6L19 13z" /></>,
  golf: <><path d="M8 4v16" /><path d="M8 5l7 2-7 2" /><path d="M5 20h8" /></>,
  machine: <><rect x="5" y="3" width="14" height="18" rx="2" /><circle cx="12" cy="8" r="2" /><path d="M9 14h6M9 17h6" /></>,
  wrench: <path d="M14 6a4 4 0 0 0-5.6 5.6L4 16v4h4l4.4-4.4A4 4 0 0 0 18 10" />,
  gamepad: <><rect x="3" y="9" width="18" height="8" rx="4" /><path d="M8 13h.01M11 13h.01M14 12h2M15 11v2" /></>,
  gift: <><rect x="3" y="9" width="18" height="11" rx="2" /><path d="M12 9v11M3 13h18" /><path d="M12 9c-2 0-4-1.1-4-2.7C8 5 8.9 4 10.3 4c1.4 0 2.3 1 1.7 5" /><path d="M12 9c2 0 4-1.1 4-2.7 0-1.3-.9-2.3-2.3-2.3-1.4 0-2.3 1-1.7 5" /></>,
  target: <><circle cx="12" cy="12" r="8" /><circle cx="12" cy="12" r="4" /><circle cx="12" cy="12" r="1.5" /></>,
  key: <><circle cx="8" cy="12" r="3" /><path d="M11 12h9M16 12v3M19 12v2" /></>,
  logout: <><path d="M15 16l4-4-4-4" /><path d="M9 12h10" /><path d="M5 4h5v3" /><path d="M5 20h5v-3" /></>,
  question: <><circle cx="12" cy="12" r="10" /><path d="M9.5 9.5a2.5 2.5 0 1 1 4.2 1.8c-.8.7-1.7 1.2-1.7 2.7" /><path d="M12 17h.01" /></>,
  card: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 10h18" /><path d="M7 14h4" /></>,
  // A scannable code, as distinct from `card` (a payment card). The membership QR is
  // held up at the door and under the machine reader, so the mark has to read as
  // "scan this", not "pay with this".
  qr: <><rect x="3.2" y="3.2" width="7" height="7" rx="1.6" /><rect x="13.8" y="3.2" width="7" height="7" rx="1.6" /><rect x="3.2" y="13.8" width="7" height="7" rx="1.6" /><path d="M13.8 13.8h3v3h-3zM20.8 13.8v3M17.8 20.8h3M13.8 20.8h1" /></>,
  dollar: <><path d="M12 4v16" /><path d="M15.5 7.5c-.7-.7-2-1.2-3.5-1.2-2.2 0-4 1.1-4 2.6s1.8 2.6 4 2.6 4 1.1 4 2.6-1.8 2.6-4 2.6c-1.5 0-2.8-.5-3.5-1.2" /></>,
  bell: <><path d="M6 16h12l-1.5-2v-3.5a4.5 4.5 0 1 0-9 0V14L6 16z" /><path d="M10 18a2 2 0 0 0 4 0" /></>,
  // Overflow: the actions that did not earn a button of their own.
  more: <><circle cx="5" cy="12" r="1.4" /><circle cx="12" cy="12" r="1.4" /><circle cx="19" cy="12" r="1.4" /></>
};

function resolveButtonProps(variant, appearance, tone) {
  if (appearance || tone) {
    return {
      appearance: appearance || 'solid',
      tone: tone || 'primary'
    };
  }

  switch (variant) {
    case 'secondary':
      return { appearance: 'solid', tone: 'secondary' };
    case 'danger':
      return { appearance: 'solid', tone: 'danger' };
    case 'ghost':
      return { appearance: 'text', tone: 'primary' };
    default:
      return { appearance: 'solid', tone: 'primary' };
  }
}

export function DSButton({
  variant = 'primary',
  appearance,
  tone,
  size = 'md',
  leadingIcon,
  trailingIcon,
  iconOnly = false,
  state = 'default',
  className = '',
  type = 'button',
  // Renders a react-router <Link> wearing the button's styling instead of a <button>.
  to,
  // Renders an <a href> for a destination outside the app.
  href,
  children,
  ...props
}) {
  const resolved = resolveButtonProps(variant, appearance, tone);
  const isIconOnly = iconOnly || (!children && (leadingIcon || trailingIcon));

  const isDisabled = props.disabled || state === 'disabled';

  const classes = [
    'ds-button',
    `ds-button--appearance-${resolved.appearance}`,
    `ds-button--tone-${resolved.tone}`,
    `ds-button--size-${size}`,
    isIconOnly ? 'ds-button--icon-only' : '',
    className
  ].filter(Boolean).join(' ');

  const content = (
    <>
      {leadingIcon ? <span className="ds-button__icon" aria-hidden="true">{leadingIcon}</span> : null}
      {children ? <span className="ds-button__label">{children}</span> : null}
      {trailingIcon ? <span className="ds-button__icon" aria-hidden="true">{trailingIcon}</span> : null}
    </>
  );

  // Same reasoning as `to`, for a destination outside the app: an <a href> rather than a
  // router <Link>. Without it, an outbound call to action either hand-writes the class
  // string or drops to a raw <a> carrying its own inline colours, which is how the
  // MatchPlay button ended up with hardcoded hex and a JS mouseover swap.
  if (href) {
    return (
      <a href={href} className={classes} data-state={state} {...props}>
        {content}
      </a>
    );
  }

  // A navigation control that LOOKS like a button still has to BE a link: it belongs in
  // the tab order as a link, opens in a new tab on ctrl-click, and is announced as a
  // link. Without this prop the call sites hand-wrote the full class string onto a
  // <Link> - four of them did exactly that - which copies the contract instead of using
  // it, so it silently stops matching the day a class name changes, and it misses the
  // icon slot that sizes the glyph.
  if (to) {
    return (
      <Link to={to} className={classes} data-state={state} {...props}>
        {content}
      </Link>
    );
  }

  return (
    <button
      type={type}
      className={classes}
      data-state={state}
      disabled={isDisabled}
      {...props}
    >
      {content}
    </button>
  );
}

// Search and filter boxes kept getting claimed by password managers. A lone text input with
// no name and a placeholder like "Search name or email" is, to Chrome's heuristics, a
// username field, so it offered saved logins on the Users page and elsewhere. These props
// tell Chrome and the common extensions (1Password, LastPass, Bitwarden/Dashlane via
// data-form-type) that the field is not a credential. DSInput applies them to every
// `type="search"` field; raw search inputs spread them directly.
export const searchFieldProps = {
  type: 'search',
  autoComplete: 'off',
  autoCorrect: 'off',
  spellCheck: false,
  'data-1p-ignore': 'true',
  'data-lpignore': 'true',
  'data-form-type': 'other',
};

export function DSInput({
  label,
  helpText,
  id,
  leadingIcon,
  trailingIcon,
  state = 'inactive',
  className = '',
  ...props
}) {
  const isDisabled = props.disabled || state === 'disabled';
  const isError = state === 'error';
  const searchDefaults = props.type === 'search' ? searchFieldProps : null;

  // Every password field gets a Show/Hide control, so people on a phone keyboard can check
  // what they typed instead of failing a login and starting over. It lives here rather than
  // on each page so no password field can be built without it.
  const isPassword = props.type === 'password';
  const [revealed, setRevealed] = React.useState(false);
  const labelId = `${React.useId()}-label`;

  const shell = (
    <span className={`ds-input-shell ds-input-shell--${state}`}>
      {leadingIcon ? <span className="ds-field-icon" aria-hidden="true">{leadingIcon}</span> : null}
      <input
        id={id}
        className={`ds-input ${className}`.trim()}
        aria-invalid={isError}
        disabled={isDisabled}
        // The reveal button sits inside the <label>, so its text would otherwise become part
        // of the field's accessible name ("Password Show"). Name the field from the label
        // text alone.
        aria-labelledby={isPassword && label ? labelId : undefined}
        {...searchDefaults}
        {...props}
        type={isPassword && revealed ? 'text' : props.type}
      />
      {isPassword ? (
        <button
          type="button"
          className="ds-input-reveal"
          onClick={() => setRevealed(!revealed)}
          aria-pressed={revealed}
          aria-label={revealed ? 'Hide password' : 'Show password'}
          disabled={isDisabled}
        >
          {revealed ? 'Hide' : 'Show'}
        </button>
      ) : null}
      {trailingIcon ? <span className="ds-field-icon" aria-hidden="true">{trailingIcon}</span> : null}
    </span>
  );

  // With no label and no help text there is nothing for the wrapper to hold, so it is not
  // rendered. That matters beyond tidiness: `.ds-field` is a full-width column flex, and
  // forcing it around a search box in a toolbar or an input in a table cell changes the
  // layout of whatever contains it. Without this, every bare input in the app had to stay
  // hand-rolled to avoid breaking its surroundings - the design system was unusable for
  // exactly the case it should have covered.
  if (!label && !helpText) {
    return shell;
  }

  return (
    <label className="ds-field" htmlFor={id}>
      {label && <span className="ds-label" id={labelId}>{label}</span>}
      {shell}
      {helpText && <span className="ds-help">{helpText}</span>}
    </label>
  );
}

export function DSSelect({
  label,
  helpText,
  id,
  state = 'inactive',
  children,
  className = '',
  ...props
}) {
  const isDisabled = props.disabled || state === 'disabled';
  const isError = state === 'error';

  const shell = (
    <span className={`ds-input-shell ds-input-shell--${state}`}>
      <select id={id} className={`ds-select ${className}`.trim()} aria-invalid={isError} disabled={isDisabled} {...props}>
        {children}
      </select>
    </span>
  );

  // See DSInput: with nothing to label, the full-width column wrapper would change the
  // layout of whatever contains the control.
  if (!label && !helpText) {
    return shell;
  }

  return (
    <label className="ds-field" htmlFor={id}>
      {label && <span className="ds-label">{label}</span>}
      {shell}
      {helpText && <span className="ds-help">{helpText}</span>}
    </label>
  );
}

export function DSTextarea({
  label,
  helpText,
  id,
  state = 'inactive',
  className = '',
  ...props
}) {
  const isDisabled = props.disabled || state === 'disabled';
  const isError = state === 'error';

  const shell = (
    <span className={`ds-input-shell ds-input-shell--${state}`}>
      <textarea id={id} className={`ds-textarea ${className}`.trim()} aria-invalid={isError} disabled={isDisabled} {...props} />
    </span>
  );

  // See DSInput.
  if (!label && !helpText) {
    return shell;
  }

  return (
    <label className="ds-field" htmlFor={id}>
      {label && <span className="ds-label">{label}</span>}
      {shell}
      {helpText && <span className="ds-help">{helpText}</span>}
    </label>
  );
}

// A card is a header over a body over a footer, with any of the three optional.
//
// Two chrome treatments, and the difference is where the card's padding lives:
//
// - `frame="inset"` (default) keeps the padding on the card. The header sits inline at
//   the top and the footer is a trailing region marked off by a rule. Used where the body
//   is free-form content the header merely introduces. This is exactly what DSCard has
//   always rendered, so every existing call site is unaffected.
// - `frame="bars"` moves the padding into the body. The header and footer become
//   full-bleed strips on their own surface with rules against the body, so the card reads
//   as a bounded block. Used where the body is a list of rows the header labels - which is
//   also why `flush` exists: rows have to reach the card edges for their separators to,
//   and a body that supplied padding would stop them short.
//
// `density="compact"` sets the title as a label rather than a display heading, for a
// header that names the rows under it rather than titling a section.
//
// `headerTone="strong"` paints the header strip. Only meaningful in `bars`, and the
// distinction is real: a strip over a list of rows reads as a column heading over its
// rows, while a strip over free-form content announces a list that is not coming.
export function DSCard({
  title,
  subtitle,
  actions,
  footer,
  frame = 'inset',
  headerTone = 'plain',
  density = 'comfortable',
  flush = false,
  variant = 'elevated',
  // No defaults here on purpose. `ds-card--bg-*` and `ds-card--border-*` are declared
  // AFTER the variant rules at equal specificity, so defaulting them meant they always
  // beat the variant and `variant` only ever controlled box-shadow - which made
  // outlined and tonal render identically. Emitting them only when a caller asks for
  // them lets `variant` work while explicit overrides still win.
  bgVariant,
  borderVariant,
  cornerVariant = 'lg',
  className = '',
  onClick,
  children,
  ...props
}) {
  const isInteractive = Boolean(onClick);
  // Only `bars` moves the padding off the card, so only `bars` needs a body element to
  // put it back. Leaving `inset` children as direct descendants is not just economy: it
  // is what makes this change invisible to the call sites that already exist.
  const hasBody = frame === 'bars' && !flush;

  return (
    <section
      className={[
        'ds-card',
        `ds-card--${variant}`,
        bgVariant ? `ds-card--bg-${bgVariant}` : '',
        borderVariant ? `ds-card--border-${borderVariant}` : '',
        `ds-card--corner-${cornerVariant}`,
        `ds-card--frame-${frame}`,
        `ds-card--header-${headerTone}`,
        `ds-card--density-${density}`,
        isInteractive ? 'ds-card--interactive' : '',
        className
      ].filter(Boolean).join(' ')}
      onClick={onClick}
      role={isInteractive ? 'button' : undefined}
      tabIndex={isInteractive ? 0 : undefined}
      onKeyDown={isInteractive ? (event) => {
        // Only the card itself activates. Without this, a Space or Enter typed
        // into any input, textarea or button nested in the card bubbles up here
        // and gets preventDefault'd, so the character never reaches the field.
        if (event.target !== event.currentTarget) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick(event);
        }
      } : undefined}
      {...props}
    >
      {(title || subtitle || actions) ? (
        <div className="ds-card-header">
          <div className="ds-card-headings">
            {title && <h2>{title}</h2>}
            {/* The subtitle belongs to the title, so it sits with it. It used to be a
                sibling of the header, pulled back up with a negative margin, which meant
                a header with actions could not keep the two together - and every page
                that hand-rolled this shape put the subtitle inside the header anyway. */}
            {subtitle && <p className="ds-card-subtitle">{subtitle}</p>}
          </div>
          {actions ? <div className="ds-card-header-actions">{actions}</div> : null}
        </div>
      ) : null}
      {hasBody ? <div className="ds-card-body">{children}</div> : children}
      {footer ? <div className="ds-card-footer">{footer}</div> : null}
    </section>
  );
}

// The bar that closes a `bars` card: "View all events", "View all 6 transactions". Full
// width, centred, on the footer surface with a rule above it, mirroring the header strip.
//
// Deliberately not a DSButton. This is a region of the card, not a control sitting inside
// one, and every DSButton appearance draws its own box - which inside the bar reads as a
// button in a bar rather than as a bar you can press.
export function DSCardFooterButton({ onClick, showArrow = true, className = '', children, ...props }) {
  return (
    <button
      type="button"
      className={['ds-card-footer-button', className].filter(Boolean).join(' ')}
      onClick={onClick}
      {...props}
    >
      {children}
      {showArrow && <span className="ds-card-footer-button-arrow" aria-hidden="true">&rarr;</span>}
    </button>
  );
}

export function DSStatTile({ label, value, subtext, tone = 'neutral', labelPosition = 'bottom',
                            onClick, className = '', ...props }) {
  // A tile that opens a detail view is a control, not a figure, so it becomes a real
  // button rather than a div with a click handler - keyboard and screen reader included.
  // Same pattern DSCard uses. The application had built this by hand.
  const Element = onClick ? 'button' : 'div';
  const interactive = onClick
    ? { type: 'button', onClick, className: 'ds-stat-tile--interactive' }
    : {};

  return (
    <Element
      className={['ds-stat-tile', `ds-stat-tile--tone-${tone}`,
                  interactive.className, className].filter(Boolean).join(' ')}
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      {...props}
    >
      {labelPosition === 'top' && <div className="ds-stat-tile-label">{label}</div>}
      <div className="ds-stat-tile-value">{value}</div>
      {labelPosition === 'bottom' && <div className="ds-stat-tile-label">{label}</div>}
      {subtext ? <div className="ds-stat-tile-subtext">{subtext}</div> : null}
    </Element>
  );
}

export function DSAlert({ variant = 'info', appearance = 'solid', children }) {
  return <div className={`ds-alert ds-alert--${variant} ds-alert--appearance-${appearance}`} role="status">{children}</div>;
}

export function DSBadge({
  variant = 'info',
  appearance = 'solid',
  size = 'md',
  uppercase = false,
  leadingIcon,
  className = '',
  children
}) {
  return (
    <span className={[
      'ds-badge',
      `ds-badge--${variant}`,
      `ds-badge--appearance-${appearance}`,
      `ds-badge--size-${size}`,
      uppercase ? 'ds-badge--uppercase' : '',
      className
    ].filter(Boolean).join(' ')}>
      {leadingIcon ? <span className="ds-badge__icon" aria-hidden="true">{leadingIcon}</span> : null}
      {children}
    </span>
  );
}

// Content-height dialog that rises from the bottom edge on mobile and centres from
// 640px up. Promoted from components/BottomSheet, which already used ds-sheet-* class
// names but lived outside the design system and drew on the legacy palette.
//
// Distinct from DSModal on purpose: DSModal is a fixed-width centred dialog at every
// size, DSSheet is content-height and edge-anchored on small screens. Pass the action
// buttons as `footer` so they stay pinned below the scrollable body.
export function DSSheet({ title, onClose, footer, children }) {
  React.useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape' && onClose) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  return (
    <div className="ds-sheet-overlay" role="presentation" onClick={onClose}>
      <div
        className="ds-sheet"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="ds-sheet-grabber" aria-hidden="true" />
        {title && <h2 className="ds-sheet-title">{title}</h2>}
        <div className="ds-sheet-body">{children}</div>
        {footer && <div className="ds-sheet-footer">{footer}</div>}
      </div>
    </div>
  );
}

// A small count anchored to the corner of whatever it labels - an unread total on a
// nav icon, an active-filter count on a filter button. Distinct from DSBadge: a badge
// sits inline in the content flow and describes it; this floats over a control and
// counts something. The app had three separate hand-rolled versions of it.
//
// The parent must establish a positioning context. `standalone` opts out of the
// absolute positioning for cases that just want the pill.
export function DSCountIndicator({ count, max = 9, tone = 'danger', label, standalone = false }) {
  const numeric = Number(count) || 0;
  if (numeric <= 0) {
    return null;
  }

  const shown = numeric > max ? `${max}+` : String(numeric);

  return (
    <span
      className={[
        'ds-count-indicator',
        `ds-count-indicator--${tone}`,
        standalone ? '' : 'ds-count-indicator--anchored'
      ].filter(Boolean).join(' ')}
      aria-label={label ? `${numeric} ${label}` : undefined}
      role={label ? 'status' : undefined}
    >
      {shown}
    </span>
  );
}

// hideClose drops the header Close button for dialogs that end with their own explicit
// action button (e.g. "Done"), where two dismiss controls side by side is just noise. The
// backdrop click still closes, so the dialog is never a trap.
export function DSModal({ title, size = 'md', onClose, hideClose = false, children }) {
  return (
    <div className="ds-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className={`ds-modal ds-modal--${size}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="ds-modal-header">
          <h3 className="ds-modal-title">{title}</h3>
          {!hideClose && <DSButton variant="ghost" onClick={onClose} aria-label="Close modal">Close</DSButton>}
        </div>
        {children}
      </div>
    </div>
  );
}

export function DSToastRegion({ children }) {
  return <div className="ds-toast-region" aria-live="polite">{children}</div>;
}

export function DSToast({ variant = 'info', appearance = 'solid', children }) {
  return <div className={`ds-toast ds-toast--${variant} ds-toast--appearance-${appearance}`}>{children}</div>;
}

export function DSTableShell({ columns = [], rows = [] }) {
  return (
    <table className="ds-table-shell">
      <thead>
        <tr>
          {columns.map((column) => <th key={column}>{column}</th>)}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, rowIndex) => (
          <tr key={`${rowIndex}-${row[0]}`}>
            {row.map((cell, cellIndex) => <td key={`${rowIndex}-${cellIndex}`}>{cell}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export function DSSplitButton({
  label,
  tone = 'primary',
  appearance = 'solid',
  size = 'md',
  // The main half IS a DSButton, and it is exactly as likely to want an icon as any
  // other button. Without this prop the call sites put the glyph inside `label`
  // instead - which is how an emoji ended up in front of "PinGolf Card ($1)".
  // Only the main half takes an icon; the toggle half already carries the caret.
  leadingIcon,
  trailingIcon,
  onMainClick,
  actions = []
}) {
  const [isOpen, setIsOpen] = React.useState(false);
  const containerRef = React.useRef(null);

  React.useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen]);

  return (
    <div className="ds-split" ref={containerRef}>
      <div className="ds-split__group">
        <DSButton appearance={appearance} tone={tone} size={size} className="ds-split__main"
                  leadingIcon={leadingIcon} trailingIcon={trailingIcon} onClick={onMainClick}>
          {label}
        </DSButton>
        <DSButton
          appearance={appearance}
          tone={tone}
          size={size}
          className="ds-split__toggle"
          aria-haspopup="menu"
          aria-expanded={isOpen}
          aria-label="Toggle split actions"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <DSIcon name="chevronDown" size="sm" tone="default" />
        </DSButton>
      </div>
      {isOpen && (
        <div className="ds-split__menu" role="menu">
          {actions.map((action, index) => (
            <button
              // `label` is allowed to be a node, so it cannot be trusted as a key - a
              // React element stringifies to "[object Object]" and every item collides.
              key={action.key ?? (typeof action.label === 'string' ? action.label : index)}
              type="button"
              className={`ds-split__menu-item ${action.tone === 'danger' ? 'is-danger' : ''}`}
              onClick={() => {
                if (action.onClick) {
                  action.onClick();
                }
                setIsOpen(false);
              }}
              disabled={action.disabled}
              role="menuitem"
            >
              {/* A real slot, so the icon is sized by the menu item rather than arriving
                  at DSIcon's own 20px default. Without it callers put the glyph inside
                  `label` and it renders nearly twice the height of the text. */}
              {action.icon
                ? <span className="ds-split__menu-item-icon" aria-hidden="true">{action.icon}</span>
                : null}
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export function DSFilterSelect({
  id,
  label,
  options = [],
  selectedValues = [],
  placeholder = 'Select filters',
  onChange
}) {
  const [isOpen, setIsOpen] = React.useState(false);
  const panelRef = React.useRef(null);

  React.useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleClickOutside = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const toggleValue = (value) => {
    const nextValues = selectedValues.includes(value)
      ? selectedValues.filter((item) => item !== value)
      : [...selectedValues, value];

    if (onChange) {
      onChange(nextValues);
    }
  };

  const selectedOptions = options.filter((option) => selectedValues.includes(option.value));

  return (
    <div className="ds-filter-select" ref={panelRef}>
      <div className="ds-filter-select__header">
        {label ? <span className="ds-filter-select__label">{label}</span> : null}
        {selectedValues.length > 0 ? (
          <button type="button" className="ds-filter-select__clear" onClick={() => onChange && onChange([])}>
            Clear
          </button>
        ) : null}
      </div>
      <button
        type="button"
        className="ds-filter-select__trigger"
        aria-expanded={isOpen}
        aria-controls={id ? `${id}-panel` : undefined}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span>{selectedOptions.length > 0 ? `${selectedOptions.length} selected` : placeholder}</span>
        <DSIcon name="chevronDown" size="sm" tone="default" />
      </button>
      {selectedOptions.length > 0 ? (
        <div className="ds-filter-select__chips">
          {selectedOptions.map((option) => (
            <span key={option.value} className="ds-filter-select__chip">{option.label}</span>
          ))}
        </div>
      ) : null}
      {isOpen && (
        <div className="ds-filter-select__panel" id={id ? `${id}-panel` : undefined} role="listbox" aria-multiselectable="true">
          {options.map((option) => (
            <div key={option.value} className="ds-filter-select__option">
              <DSCheckbox
                id={`${id || 'filter'}-${option.value}`}
                label={option.label}
                checked={selectedValues.includes(option.value)}
                onChange={() => toggleValue(option.value)}
                state="default"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export function DSTypeaheadFilterSelect({
  id,
  label,
  options = [],
  selectedValues = [],
  placeholder = 'Search and select',
  emptyMessage = 'No matches found',
  maxVisibleOptions = 60,
  onChange
}) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [query, setQuery] = React.useState('');
  const panelRef = React.useRef(null);

  React.useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleClickOutside = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen]);

  const toggleValue = (value) => {
    const nextValues = selectedValues.includes(value)
      ? selectedValues.filter((item) => item !== value)
      : [...selectedValues, value];

    if (onChange) {
      onChange(nextValues);
    }
  };

  const normalizedQuery = query.trim().toLowerCase();
  const matchingOptions = normalizedQuery
    ? options.filter((option) => option.label.toLowerCase().includes(normalizedQuery))
    : options;
  const visibleOptions = matchingOptions.slice(0, maxVisibleOptions);
  const hasMoreResults = matchingOptions.length > visibleOptions.length;

  const selectedOptions = options.filter((option) => selectedValues.includes(option.value));

  return (
    <div className="ds-typeahead-filter-select" ref={panelRef}>
      <div className="ds-filter-select__header">
        {label ? <span className="ds-filter-select__label">{label}</span> : null}
        {selectedValues.length > 0 ? (
          <button type="button" className="ds-filter-select__clear" onClick={() => onChange && onChange([])}>
            Clear
          </button>
        ) : null}
      </div>

      <button
        type="button"
        className="ds-filter-select__trigger"
        aria-expanded={isOpen}
        aria-controls={id ? `${id}-panel` : undefined}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span>{selectedOptions.length > 0 ? `${selectedOptions.length} selected` : placeholder}</span>
        <DSIcon name="chevronDown" size="sm" tone="default" />
      </button>

      {selectedOptions.length > 0 ? (
        <div className="ds-filter-select__chips">
          {selectedOptions.map((option) => (
            <span key={option.value} className="ds-filter-select__chip">{option.label}</span>
          ))}
        </div>
      ) : null}

      {isOpen && (
        <div className="ds-typeahead-filter-select__panel" id={id ? `${id}-panel` : undefined} role="listbox" aria-multiselectable="true">
          <div className="ds-typeahead-filter-select__search-shell">
            <DSIcon name="search" size="sm" tone="muted" />
            <input
              {...searchFieldProps}
              className="ds-typeahead-filter-select__search"
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              placeholder="Type to filter options"
              autoFocus
            />
          </div>

          <div className="ds-typeahead-filter-select__results">
            {visibleOptions.length > 0 ? (
              visibleOptions.map((option) => (
                <div key={option.value} className="ds-filter-select__option">
                  <DSCheckbox
                    id={`${id || 'typeahead'}-${option.value}`}
                    label={option.label}
                    checked={selectedValues.includes(option.value)}
                    onChange={() => toggleValue(option.value)}
                    state="default"
                  />
                </div>
              ))
            ) : (
              <p className="ds-typeahead-filter-select__empty">{emptyMessage}</p>
            )}
          </div>

          {hasMoreResults ? (
            <p className="ds-typeahead-filter-select__hint">
              Showing first {maxVisibleOptions} results. Keep typing to narrow the list.
            </p>
          ) : null}
        </div>
      )}
    </div>
  );
}

export function DSCheckbox({
  id,
  label,
  checked = false,
  state = 'default',
  disabled = false,
  onChange,
  ...props
}) {
  const resolvedState = disabled || state === 'disabled' ? 'disabled' : state;

  return (
    <label className={`ds-choice ds-choice--${resolvedState}`} htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        className="ds-choice-input"
        checked={checked}
        disabled={resolvedState === 'disabled'}
        onChange={onChange}
        {...props}
      />
      <span className={`ds-checkbox-box ${checked ? 'is-checked' : ''}`} aria-hidden="true">
        {checked ? <DSIcon name="check" size="sm" tone="inverse" /> : null}
      </span>
      {label ? <span className="ds-choice-label">{label}</span> : null}
    </label>
  );
}

export function DSRadio({
  id,
  name,
  label,
  checked = false,
  state = 'default',
  disabled = false,
  onChange,
  ...props
}) {
  const resolvedState = disabled || state === 'disabled' ? 'disabled' : state;

  return (
    <label className={`ds-choice ds-choice--${resolvedState}`} htmlFor={id}>
      <input
        id={id}
        type="radio"
        name={name}
        className="ds-choice-input"
        checked={checked}
        disabled={resolvedState === 'disabled'}
        onChange={onChange}
        {...props}
      />
      <span className={`ds-radio-ring ${checked ? 'is-checked' : ''}`} aria-hidden="true">
        <span className="ds-radio-dot" />
      </span>
      {label ? <span className="ds-choice-label">{label}</span> : null}
    </label>
  );
}

export function DSToggle({
  id,
  label,
  checked = false,
  state = 'default',
  disabled = false,
  onChange,
  ...props
}) {
  const resolvedState = disabled || state === 'disabled' ? 'disabled' : state;

  return (
    <label className={`ds-choice ds-choice--${resolvedState}`} htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        role="switch"
        className="ds-choice-input"
        checked={checked}
        disabled={resolvedState === 'disabled'}
        onChange={onChange}
        {...props}
      />
      <span className={`ds-toggle-track ${checked ? 'is-checked' : ''}`} aria-hidden="true">
        <span className="ds-toggle-thumb" />
      </span>
      {label ? <span className="ds-choice-label">{label}</span> : null}
    </label>
  );
}

// `eyebrow` is the small label above the title that says which surface you are on
// (e.g. "Host Controls") - a kicker, not a sentence. It reads before the title on
// purpose: the title is the thing's name and the eyebrow is what you are doing to it.
// Distinct from `description`, which is a sentence under the title.
export function DSPageHeader({ title, eyebrow, description, actions }) {
  return (
    <header className="ds-page-header">
      {(title || eyebrow || description) && (
        <div>
          {eyebrow && <p className="ds-page-header__eyebrow">{eyebrow}</p>}
          {title && <h1>{title}</h1>}
          {description && <p>{description}</p>}
        </div>
      )}
      {actions ? <div className="ds-page-header__actions">{actions}</div> : null}
    </header>
  );
}

// A fixed bottom tab bar for the app's member-facing surfaces.
//
// The application had five hand-rolled bottom navigations (My Account, Machine, Events,
// Competition, PinGolf, Developer) sharing a `BottomNavShell.css` for the fixed
// positioning and each carrying its own palette. This is the design-system version:
// the bar, the item states, the count, and the optional centre action, all from tokens.
//
// Two things it does that a row of buttons does not:
//
// - **The centre action.** Pass `centerAction` and the bar reserves a column for it and
//   floats it above the bar's top edge as a circle in `actionPrimaryBg`. It is not a
//   tab: it is for the one object on the surface that has to be reachable from every
//   tab in one tap. It carries no label, because a 62px yellow circle overhanging a
//   purple bar is not something anyone needs a word for.
// - **Selected state that is not only colour.** The active item uses the solid variant
//   of its icon as well as a brighter colour and a heavier label, so the selection
//   survives a colour-vision difference and a dim room.
//
// Items are data, not children, so every bar in the app is the same construction:
//   items: [{ key, icon, label, active, onClick, count, countLabel }]
export function DSBottomNav({ items = [], centerAction, ariaLabel = 'Sections', className = '' }) {
  const renderItem = (item) => (
    <button
      key={item.key}
      type="button"
      className={`ds-bottom-nav__item ${item.active ? 'is-active' : ''}`}
      aria-current={item.active ? 'page' : undefined}
      onClick={item.onClick}
    >
      <span className="ds-bottom-nav__icon">
        <DSIcon name={item.icon} size="lg" filled={item.active} />
        {/* Brand tone, not the default danger red. On a purple bar the count is
            drawing the eye to work that is waiting, which is not an alarm, and red
            on purple is the one pairing that does not carry at arm's length. The
            bar positions it; the pill itself is the shared one. */}
        {item.count > 0 && (
          <span className="ds-bottom-nav__count">
            <DSCountIndicator count={item.count} tone="brand" standalone label={item.countLabel} />
          </span>
        )}
      </span>
      <span className="ds-bottom-nav__label">{item.label}</span>
    </button>
  );

  // With a centre action the items split evenly around a reserved middle column, so an
  // odd number of items would leave the bar visibly lopsided. Splitting at the halfway
  // point keeps it balanced whatever the count.
  const splitAt = centerAction ? Math.ceil(items.length / 2) : items.length;

  return (
    <div className={`ds-bottom-nav-dock ${className}`.trim()}>
      <nav
        className={`ds-bottom-nav ${centerAction ? 'ds-bottom-nav--with-center' : ''}`}
        aria-label={ariaLabel}
        style={centerAction ? {
          gridTemplateColumns: `repeat(${splitAt}, 1fr) 84px repeat(${items.length - splitAt}, 1fr)`
        } : {
          gridTemplateColumns: `repeat(${items.length}, 1fr)`
        }}
      >
        {centerAction && (
          <button
            type="button"
            className={`ds-bottom-nav__center ${centerAction.active ? 'is-active' : ''}`}
            aria-label={centerAction.label}
            aria-expanded={centerAction.active}
            onClick={centerAction.onClick}
          >
            <DSIcon name={centerAction.active ? 'x' : centerAction.icon} size="xl" />
          </button>
        )}

        {items.slice(0, splitAt).map(renderItem)}
        {centerAction && <span className="ds-bottom-nav__gap" aria-hidden="true" />}
        {items.slice(splitAt).map(renderItem)}
      </nav>
    </div>
  );
}

// Horizontal tab bar for switching between sections of one screen.
//
// Listed in the UI contract's approved primitives since phase 1 but never actually built,
// so every screen that needed tabs either hand-rolled them or stacked its sections into
// one long scroll. Items are data, matching DSBottomNav:
//   items: [{ key, label, count, dot }]
//
// `count` renders a pill (a section with 3 pending requests says so before you open it);
// `dot` renders a small status marker for "something needs attention here".
export function DSTabs({ items = [], activeKey, onSelect, ariaLabel = 'Sections', className = '' }) {
  const handleKeyDown = (event, index) => {
    const last = items.length - 1;
    let nextIndex = null;

    if (event.key === 'ArrowRight') nextIndex = index === last ? 0 : index + 1;
    if (event.key === 'ArrowLeft') nextIndex = index === 0 ? last : index - 1;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = last;

    if (nextIndex === null) return;

    event.preventDefault();
    const next = items[nextIndex];
    if (next && onSelect) onSelect(next.key);
  };

  return (
    <div className={['ds-tabs', className].filter(Boolean).join(' ')} role="tablist" aria-label={ariaLabel}>
      {items.map((item, index) => {
        const isActive = item.key === activeKey;

        return (
          <button
            key={item.key}
            type="button"
            role="tab"
            id={`ds-tab-${item.key}`}
            aria-selected={isActive}
            aria-controls={`ds-tabpanel-${item.key}`}
            tabIndex={isActive ? 0 : -1}
            className={['ds-tabs__tab', isActive ? 'is-active' : ''].filter(Boolean).join(' ')}
            onClick={() => onSelect && onSelect(item.key)}
            onKeyDown={(event) => handleKeyDown(event, index)}
          >
            <span className="ds-tabs__label">{item.label}</span>
            {item.count > 0 ? <span className="ds-tabs__count">{item.count}</span> : null}
            {item.dot ? <span className={`ds-tabs__dot ds-tabs__dot--${item.dot}`} aria-hidden="true" /> : null}
          </button>
        );
      })}
    </div>
  );
}

export function DSTabPanel({ tabKey, activeKey, children }) {
  if (tabKey !== activeKey) {
    return null;
  }

  return (
    <div role="tabpanel" id={`ds-tabpanel-${tabKey}`} aria-labelledby={`ds-tab-${tabKey}`} className="ds-tabpanel">
      {children}
    </div>
  );
}

export function DSBackgroundStage({ mode = 'vivid', className = '', children }) {
  return (
    <div className={[
      'ds-background-stage',
      `ds-background-stage--${mode}`,
      className
    ].filter(Boolean).join(' ')}>
      {children}
    </div>
  );
}

/* The single back-navigation control. Every "Back to ..." in the app routes through
   here - see docs/DESIGN_SYSTEM_BACK_NAV.md for the rules.

   tone:     'plain' (default) chromeless white, self-scrimmed, works on hero photos
             and flat surfaces alike | 'subtle' muted, for back links sitting inline
             next to body copy.
   size:     'sm' | 'md' (default) | 'lg'.
   iconOnly: renders the arrow alone for cramped headers. The label stays in the DOM
             and is clipped, so screen readers still announce the destination - which
             is why there is no aria-label to remember. */
export function DSBackLink({
  to,
  href,
  onClick,
  tone = 'plain',
  size = 'md',
  iconOnly = false,
  className = '',
  children,
  ...props
}) {
  const resolvedLabel = children || 'Back';
  const iconSize = size === 'lg' ? 'md' : size;
  const classes = [
    'ds-back-link',
    `ds-back-link--${tone}`,
    `ds-back-link--${size}`,
    iconOnly ? 'ds-back-link--icon-only' : '',
    className
  ].filter(Boolean).join(' ');

  const content = (
    <>
      <DSIcon name="arrowLeft" size={iconSize} />
      <span className="ds-back-link__label">{resolvedLabel}</span>
    </>
  );

  if (to) {
    return (
      <Link to={to} className={classes} onClick={onClick} {...props}>
        {content}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} onClick={onClick} {...props}>
        {content}
      </a>
    );
  }

  return (
    <button type="button" className={classes} onClick={onClick} {...props}>
      {content}
    </button>
  );
}

export function DSAccordion({ className = '', children }) {
  return <div className={['ds-accordion', className].filter(Boolean).join(' ')}>{children}</div>;
}

export function DSAccordionItem({ title, subtitle, defaultOpen = false, className = '', children }) {
  return (
    <details className={['ds-accordion-item', className].filter(Boolean).join(' ')} open={defaultOpen}>
      <summary className="ds-accordion-item__summary">
        <span className="ds-accordion-item__summary-main">
          <span className="ds-accordion-item__title">{title}</span>
          {subtitle ? <span className="ds-accordion-item__subtitle">{subtitle}</span> : null}
        </span>
        <span className="ds-accordion-item__icon" aria-hidden="true">
          <DSIcon name="chevronDown" size="sm" tone="brand" />
        </span>
      </summary>
      <div className="ds-accordion-item__panel">
        {children}
      </div>
    </details>
  );
}

// Solid counterparts for the handful of icons that need to carry a selected state.
// The whole set is stroked line art, which is right for chrome but gives a navigation
// nothing to say "you are here" with beyond colour, and colour alone is not enough
// (WCAG 1.4.1). Each of these fills the icon's inner shape and keeps the outline, so a
// filled and an unfilled icon read as the same glyph in two states rather than two
// different glyphs. Only add one here when a component genuinely needs the pair.
const filledIconPaths = {
  home: <><path d="M5 10v10h14V10z" fill="currentColor" stroke="none" /><path d="M3 11l9-8 9 8" /><path d="M5 10v10h14V10" /></>,
  trophy: <><path d="M8 4h8v3a4 4 0 0 1-8 0V4z" fill="currentColor" stroke="none" /><path d="M8 4h8v3a4 4 0 0 1-8 0V4z" /><path d="M10 14h4M9 18h6" /><path d="M7 6H5a2 2 0 0 0 0 4h2" /><path d="M17 6h2a2 2 0 1 1 0 4h-2" /></>,
  user: <><circle cx="12" cy="8" r="4" fill="currentColor" stroke="none" /><circle cx="12" cy="8" r="4" /><path d="M4 20c1.5-3.5 4.4-5 8-5s6.5 1.5 8 5" /></>,
  clipboard: <><path d="M9 3h6v3H9z" fill="currentColor" stroke="none" /><rect x="7" y="4" width="10" height="17" rx="2" /><path d="M9 4V3h6v1" /><path d="M9 10h6M9 14h6" /></>,
  // The bell fills its body but leaves the clapper stroked, so the shape still reads
  // as a bell rather than as a solid blob at 20px.
  bell: <><path d="M6 16h12l-1.5-2v-3.5a4.5 4.5 0 1 0-9 0V14L6 16z" fill="currentColor" stroke="none" /><path d="M6 16h12l-1.5-2v-3.5a4.5 4.5 0 1 0-9 0V14L6 16z" /><path d="M10 18a2 2 0 0 0 4 0" /></>
};

export function DSIcon({ name, size = 'md', tone = 'default', filled = false, label }) {
  // Falls back to the outline when an icon has no solid counterpart, so `filled` is
  // always safe to pass and never renders a wrong glyph.
  const glyph = (filled && filledIconPaths[name]) || iconPaths[name] || iconPaths.info;

  return (
    <span className={`ds-icon ds-icon--${size} ds-icon--${tone}`} aria-hidden={label ? undefined : true}>
      <svg viewBox="0 0 24 24" role={label ? 'img' : undefined} aria-label={label}>
        {glyph}
      </svg>
    </span>
  );
}
